import React, { Component } from 'react'
import { FormattedMessage, FormattedDate, FormattedTime, injectIntl, intlShape } from 'react-intl'
import { filter, toString, map, get, each } from 'lodash'
import download from 'downloadjs'
import $ from 'jquery'

import FaIcon from '../components/FaIcon'

import { Table, Input, Button, Menu, Dropdown, Select } from 'antd'
const Option = Select.Option



class DataTable extends Component {

    static propTypes = {
        intl: intlShape.isRequired
    }

    state = {
        pageSize: 10,
        search: ''
    }

    onSearch = (e) => {
        this.setState({ search: e.target.value.toLowerCase() })
    }

    onPageSizeChange = (value) => {
        this.setState({ pageSize: parseInt(value, 10) })
    }

    downloadCsv = () => {
        const { dataSource, columns, intl } = this.props
        const columnsToExport = filter(columns, column => column.csv === true || column.csv === undefined || column.csv === null);

        let csvString = ""
        csvString += map(columnsToExport, column => column.title).join(';') + '\n'
        csvString += map(dataSource, value => (
            map(columnsToExport, column => {
                const val = get(value, column.dataIndex)
                if (column.type === 'date') {
                    return intl.formatDate(val)
                } else if (column.type === 'datetime') {
                    return intl.formatDate(val) + " - " + intl.formatTime(val)
                }
                return val
            }).join(';')
        )).join('\n')
        download(csvString, "export.csv", "text/csv");
    }

    print = () => {
        const { dataSource, columns, intl } = this.props

        const columnsToExport = filter(columns, column => column.csv === true || column.csv === undefined || column.csv === null);
        // Head
        let head = `<style>
        body {
            font-family: "Monospaced Number", Helvetica, Arial, sans-serif;
            font-size: 14px;
            line-height: 1.5;
            font-weight: 400;
        }
        table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            text-align: left;
            border-radius: 4px 4px 0 0;
        }
        table th {
            padding: 8px 8px;
        }
        table td {
            padding: 4px 8px;
        }
        table thead th {
            background: #fafafa;
            color: rgba(0, 0, 0, 0.85);
            font-weight: bold;
            border-bottom: 1px solid #e8e8e8;
        }
        table tbody td {
            border-bottom: 1px solid #e8e8e8;
        }
        </style>`
        // Body
        let body = "<table><thead><tr>"
        body += map(columnsToExport, column => "<th>" + column.title + "</th>").join("") + '\n'
        body += "</tr></thead><tbody>"
        each(dataSource, value => {
            body += "<tr>"
            body += map(columnsToExport, column => {
                const val = get(value, column.dataIndex)
                if (column.type === 'date') {
                    return "<td>" + intl.formatDate(val) + "</td>"
                } else if (column.type === 'datetime') {
                    return "<td>" + intl.formatDate(val) + " - " + intl.formatTime(val) + "</td>"
                }
                return "<td>" + (val === null || val === undefined ? "" : val) + "</td>"
            }).join("")
            body += "</tr>"
        })
        body += "</tbody></table>"
        body += "<script>setTimeout(window.print, 500)</script>"
        // Open window
        var w = window.open()
        $(w.document.body).html(body)
        $(w.document.head).html(head)
    }

    handleMenuClick = ({ key }) => {
        switch(key) {
            case 'csv':
                this.downloadCsv()
                break
            case 'print':
                this.print()
                break
            default:
                break
        }
        
    }

    render() {
        const { intl } = this.props
        let props = Object.assign({}, this.props)

        // Filter datasource
        props.dataSource = filter(props.dataSource, (item) => {
            for (let column of props.columns) {
                // Ignore columns with no dataIndex
                if (!column.dataIndex) continue;
                const value = get(item, column.dataIndex)
                // Check by type
                switch (column.type) {
                    case 'string': if (value && value.toLowerCase().indexOf(this.state.search) !== -1) return true; else break
                    case 'date': if (value && intl.formatDate(value).indexOf(this.state.search) !== -1) return true; else break
                    case 'datetime': if (value && (intl.formatDate(value) + " - " + intl.formatTime(value)).indexOf(this.state.search) !== -1) return true; else break
                    case 'number': if (toString(value).indexOf(this.state.search) !== -1) return true; else break
                    default: break
                }
            }
            return false
        })

        // Add sorders, renderers, translated titles...
        for (let column of props.columns) {
            // Translate column titles if necessary
            if (typeof column.title === 'string' && column.formatTitle !== false) {
                column.title = intl.formatMessage({id: column.title})
                column.formatTitle = false
            }
            // Render dates
            if (!column.render && column.type === 'date') {
                column.render = (value) => (
                    value ? <FormattedDate value={value} /> : null
                )
            }
            // Render datetime
            if (!column.render && column.type === 'datetime') {
                column.render = (value) => (
                    value ? <span><FormattedDate value={value} /> - <FormattedTime value={value} /></span> : null
                )
            }
            // Render booleans
            if (!column.render && column.type === 'boolean') {
                column.render = (value) => {
                    if (typeof value === 'boolean') {
                        if (column.inverted) {
                            return !value ? <FaIcon icon="check" color="green" /> : <FaIcon icon="times" color="red" />
                        } else {
                            return value ? <FaIcon icon="check" color="green" /> : <FaIcon icon="times" color="red" />
                        }
                    }
                }
            }
            // Sort strings
            if (column.sorter === true && column.dataIndex && column.type === 'string') {
                column.sorter = (a, b) => get(a, column.dataIndex).localeCompare(get(b, column.dataIndex))
            }
            // Sort dates
            if (column.sorter === true && column.dataIndex && (column.type === 'date' || column.type === 'datetime')) {
                column.sorter = (a, b) => new Date(get(a, column.dataIndex)) - new Date(get(b, column.dataIndex))
            }
            // Sort numbers
            if (column.sorter === true && column.dataIndex && column.type === 'number') {
                column.sorter = (a, b) => get(a, column.dataIndex) - get(b, column.dataIndex)

            }
        }

        // Handle pagination
        if (!props.pagination) {
            props.pagination= {
                pageSize: this.state.pageSize,
                showTotal: (total, range) => <FormattedMessage id="misc.table.total" values={{total, start: range[0], end: range[1]}} />
            }
        }

        const menu = (
            <Menu onClick={this.handleMenuClick}>
              <Menu.Item key="print"><FaIcon icon="print" fixedWidth style={{ marginRight: 3 }} /> <FormattedMessage id="misc.print" /></Menu.Item>
              <Menu.Item key="csv"><FaIcon icon="file-excel" fixedWidth style={{ marginRight: 3 }} /> <FormattedMessage id="misc.downloadCSV" /></Menu.Item>
            </Menu>
        );

        props.title = () =>
            (<div style={{ display: "flex", justifyContent: "space-between" }}>
                <Select defaultValue="10" onChange={this.onPageSizeChange}>
                    <Option value="10">10 / <FormattedMessage id="misc.table.page" /></Option>
                    <Option value="20">20 / <FormattedMessage id="misc.table.page" /></Option>
                    <Option value="30">30 / <FormattedMessage id="misc.table.page" /></Option>
                    <Option value="40">40 / <FormattedMessage id="misc.table.page" /></Option>
                </Select>
                <div>
                    <Input placeholder="Rechercher..." onChange={this.onSearch} style={{ width: 200 }} suffix={<FaIcon icon="search" />} />
                    <Dropdown overlay={menu} >
                        <Button style={{ marginLeft: 5 }} hidden={!this.props.export}>
                            <FaIcon icon="ellipsis-v" style={{ marginRight: 0 }} />
                        </Button>
                    </Dropdown>
                </div>
            </div>)

        // Return table
        return(
            <Table {...props} />
        )
    }

}

export default injectIntl(DataTable)


// WEBPACK FOOTER //
// ./src/components/DataTable.js